import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { formatDateTimeDiffNow, formatUpdatedDateTime } from 'src/lib/format';

import { useStyles } from './useStyles';

export const ProjectDescription = ({ className, classes, project, diffNow }) => {
  const styles = useStyles({ classes });

  const dateModified = useMemo(() => {
    if (diffNow) {
      return formatDateTimeDiffNow(project.editedAt);
    } else {
      return formatUpdatedDateTime(project.editedAt);
    }
  }, [project, diffNow]);

  return (
    <div className={cx(styles.root, className)}>
      <TruncatedTypography variant={TYPOGRAPHY_VARIANT.regular14}>
        {dateModified} by{' '}
        {project.lastModifyingUser?.name || project.lastModifyingUser?.email?.split('@')?.[0]}
      </TruncatedTypography>
    </div>
  );
};

ProjectDescription.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape(),
  project: PropTypes.shape().isRequired,
  diffNow: PropTypes.bool,
};
ProjectDescription.defaultProps = {
  className: null,
  classes: null,
  diffNow: false,
};
